import { render, staticRenderFns } from "./SimpleFnolPage.vue?vue&type=template&id=3d0d9ce1&"
import script from "./SimpleFnolPage.vue?vue&type=script&lang=js&"
export * from "./SimpleFnolPage.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFnolPage.vue?vue&type=style&index=0&id=3d0d9ce1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports